export const API = {
    GET_RETURN_SALES_ORDERS: "/api/v1/returnSalesOrder/GetReturnSalesOrder",
    GET_RETURN_SALES_ORDER_ITEMS: "/api/v1/returnSalesOrder/GetReturnSalesOrderItemByReturnSalesOrderId",
    REJECT_RETURN_SALES_ORDER_ITEM_QC: "/api/v1/returnSalesOrder/RejectReturnSalesOrderItemQC",
    CALCULATE_RETURN_SALES_ORDER_ITEM_PRICES: "/api/v1/returnSalesOrder/CalculatereturnSalesOrderItemPrices",
    COMPLETE_RETURN_SALES_ORDER_QC: "/api/v1/ReturnSalesOrder/ComplateReturnOrderQC"
}